//The Account settings view navigation modal

import React from 'react';
import MobileNavigationModal from './MobileNavigationModal';
import { InjectedFormProps } from 'redux-form';
import NavigationDrawer from './NavigationDrawer';

export const MobileNavigationAccountSettings: React.FC<InjectedFormProps> = (
  props
) => {
  return (
    <MobileNavigationModal {...props}>
      <NavigationDrawer
        variant={'account-settings'}
        isAdmin={true}
        rootUrl={'/account/settings/'}
      />
    </MobileNavigationModal>
  );
};
